export const RELATIONSHIP_OPTIONS = [
  'Charge Nurse',
  'Assistant Manager',
  'Manager',
  'Unit Supervisor',
  'Director',
].map((o) => ({
  value: o,
  label: o,
}));

export const MODAL_TEXT = ({
  firstName,
  referralUrl,
}: {
  firstName: string;
  referralUrl: string;
}) => {
  return `Hi ${firstName}, I have added you as a reference on Medely. Please follow the link below to verify your information. Thanks!\n${referralUrl}`;
};
